const filterDestinationsFromFeaturedProperties = (destinations, properties) =>
  destinations.filter(({ name }) =>
    properties.some(
      ({ propertyContent: { destination } }) => destination.name === name,
    ),
  );

export default filterDestinationsFromFeaturedProperties;
